export const METASITE_APP_DEF_ID = '22bef345-3c5b-4c18-b782-74d4085112ff'
export const VIEWER_SERVICE_EXTENSION_NAME = 'VIEWER_SERVICE'
